import React from "react";
import ModalDisplay from "./ModalDisplay";
import Div from "../../components/common/Div";
import Text from "../../components/common/Text";
import ModalButton from "../../components/common/ModalButton";
import { tenzero } from "../../constants/Constants";
import { Typography } from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";

export default function ReviewBox(props) {
  let displayValue = "none";
  if (props.display) displayValue = "block";

  function clickNoHandler() {
    props.handler1(false); // calls setReviewDisplay(false), hiding the modal
  }

  return (
    <ModalDisplay display={displayValue} style={modalStyle}>
      <div style={iconContainerStyle}>
        <SearchIcon style={successIconStyle} />
      </div>
      <Div margin={tenzero}>
        <Typography
          fontWeight={"bold"}
          color={"rgb(33, 42, 65)"}
          style={{ fontSize: "1.25rem", textAlign: "center" }}
        >
          Review Test
        </Typography>
      </Div>
      <Div margin={tenzero}>
        <Text color={"rgb(33, 42, 65)"} fontSize={"0.9rem"}>
          Would you like to review your answers before submitting?
        </Text>
      </Div>
      <Div style={buttonContainerStyle}>
        <ModalButton onClick={clickNoHandler}>Cancel</ModalButton>
        <ModalButton onClick={props.handler2}>Confirm</ModalButton>
      </Div>
    </ModalDisplay>
  );
}

// Styling for modal components
const modalStyle = {
  width: "320px",
  padding: "20px",
  background: "#FFFFFF",
  borderRadius: "12px",
  boxShadow: "0 4px 10px rgba(0, 0, 0, 0.1)",
  textAlign: "center",
};

const iconContainerStyle = {
  display: "flex",
  width: "fit-content",
  justifyContent: "center",
  marginBottom: "15px",
  backgroundColor: "rgb(33, 42, 65, 0.3)",
  borderRadius: "20%",
  padding: "10px",
  margin: "0 auto",
};

const successIconStyle = {
  color: "rgb(33, 42, 65)",
  fontSize: "2rem",
};

const warningIconStyle = {
  color: "#F44336",
  fontSize: "2.5rem",
};

const textStyle = {
  fontSize: "0.8rem",
  color: "#6B7280",
  marginBottom: "20px",
};

const buttonContainerStyle = {
  display: "flex",
  flexDirection: "column",
  gap: "10px",
};
